import { toNewsPost } from '../models/mapper'
import { NewsPost, NewsPostUpdateRequest } from '../models/types'
import { updateNewsPostV1 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function updateNewsPost(id: number, request: NewsPostUpdateRequest): Promise<NewsPost> {
  return toNewsPost(await updateNewsPostV1(id, request))
}
